module.exports = __webpack_public_path__ + "img/logo.15d8d947.png";